import { useEffect } from "react";
import Lenis from "lenis";
import { Navbar } from "@/components/landing/Navbar";
import { Hero } from "@/components/landing/Hero";
import { Marquee } from "@/components/landing/Marquee";
import { DisclaimerStrip } from "@/components/landing/DisclaimerStrip";
import { AreasSection } from "@/components/landing/AreasSection";
import { Rooms } from "@/components/landing/Rooms";
import { Transfers } from "@/components/landing/Transfers";
import { Process } from "@/components/landing/Process";
import { EnquiryForm } from "@/components/landing/EnquiryForm";
import { Trust, Testimonials, Faq, Policies } from "@/components/landing/Sections";
import { Footer } from "@/components/landing/Footer";
import { useSeo } from "@/lib/seo";

export default function Landing() {
  useSeo(
    "Delhi Airport Stay & Transit Services · Rooms near IGI Airport",
    "Verified hotel rooms near IGI Airport, Yashobhoomi & Kapashera Border, Delhi. Actual photos on chat before you pay. Book with 30% advance after approval."
  );

  useEffect(() => {
    const lenis = new Lenis({ autoRaf: true, anchors: true });
    return () => lenis.destroy();
  }, []);

  useEffect(() => {
    if (window.location.hash) {
      const timer = setTimeout(() => {
        document.querySelector(window.location.hash)?.scrollIntoView({ behavior: "smooth" });
      }, 500);
      return () => clearTimeout(timer);
    }
  }, []);

  return (
    <div className="site-shell">
      <Navbar />
      <main>
        <Hero />
        <Marquee />
        <DisclaimerStrip />
        <AreasSection />
        <Rooms />
        <Transfers />
        <Process />
        <EnquiryForm />
        <Trust />
        <Testimonials />
        <Faq />
        <Policies />
      </main>
      <Footer />
    </div>
  );
}
